import { PayloadAction } from '../../../../../store.model';
import { TranscriptCategories } from '../model/transcript-categories.model';
import { ActionType } from '../transcript-summary.action';
import { TranscriptSummaryState } from '../transcript-summary.state';

import { ToggleCategory } from './toggle-category.action';

export function toggleCategoryReducer(
    state: TranscriptSummaryState,
    action: PayloadAction<ActionType, ToggleCategory>,
): TranscriptSummaryState {
    const nextCats = state.transcriptCategories.map<TranscriptCategories>(
        (cat) => {
            // TODO FIXME label compare
            if (cat.label === action.payload.category.label) {
                return {
                    ...cat,
                    isOpen: action.payload.isOpen,
                };
            }
            return cat;
        },
    );

    const nextFiltered =
        state.filteredTranscriptCategories.map<TranscriptCategories>((cat) => {
            if (cat === action.payload.category) {
                return {
                    ...cat,
                    isOpen: action.payload.isOpen,
                };
            }
            return cat;
        });

    return {
        ...state,
        transcriptCategories: nextCats,
        filteredTranscriptCategories: nextFiltered,
    };
}
